import React from 'react';
import { FileText } from '@onward-delivery/design/icons';
import ComplianceBadges from './ComplianceBadges';
import SettingCard from './SettingCard';

const DocumentsCard = ({ compliance, onUpload }) => {
    const card = { key: 'documents', title: 'Documents', satisfied: compliance.every((doc) => doc.satisfied) };

    return (
        <SettingCard card={card} icon={FileText}>
            <ComplianceBadges compliance={compliance} onUpload={onUpload} />
        </SettingCard>
    );
};

export default DocumentsCard;
